export const teal = '#00b1c5'
export const tealDark = '#008392'
